/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Cost_Calc_Credit_PoolInputs */



/**
* | output |
* | --- |
* | "Includes €{amount}/mo AI credit pool" |
*
* @param {Cost_Calc_Credit_PoolInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_calc_credit_pool = /** @type {((inputs: Cost_Calc_Credit_PoolInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Calc_Credit_PoolInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Inkl. €${i?.amount}/Mo. KI-Credit-Pool`)
	return /** @type {LocalizedString} */ (`Includes €${i?.amount}/mo AI credit pool`)
});